import axios from 'axios';

const url = 'https://io.lan1.net/';

export default {
  postStatusRequest(credentials) {
    return this.customPost('v7/status', credentials)
  },
  postPasswordRequest(credentials) {
    return this.customPost('v7/password', credentials)
  },
    customPost(target, credentials) {
        return axios.post(url + target, credentials).then(response => response).catch(e => e.response);
  },
};


